import { render, staticRenderFns } from "./ed-move-lessons-modal.component.vue?vue&type=template&id=427b47f6&scoped=true&"
import script from "./ed-move-lessons-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-move-lessons-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-move-lessons-modal.component.scss?vue&type=style&index=0&id=427b47f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b47f6",
  null
  
)

export default component.exports